import {
  ReportSection,
  ReportSectionConfigurationBase,
  ReportType,
  ReportViewModelSection
} from '@capital-access/reporting/common';
import { PeerOwnershipInstitutionsGlobalViewModel } from './peer-ownership-institutions.model';

export class PeerOwnershipInstitutionsGlobalConfiguration extends ReportSectionConfigurationBase {
  typeName = 'PeerOwnershipInstitutionsGlobalConfiguration';
  nodataLocalizationKeyName = 'peerOwnershipInstitutions';
  readonly reportSection = ReportSection.PeerOwnershipInstitutions;
  readonly name = 'peerOwnershipInstitutions';
  readonly displayName = 'Institutions - Global';
  readonly applicableReportTypes = [ReportType.PeerOwnershipReport];
  readonly reportViewModelSections = [ReportViewModelSection.PeerOwnershipReport_InstitutionsGlobal];
  minSize = 4;
  maxSize = 4;
  defaultSize = 4;
  readonly availableDataSections = [];
}

export interface PeerOwnershipInstitutionsGlobalDataBag {
  [ReportViewModelSection.PeerOwnershipReport_InstitutionsGlobal]: PeerOwnershipInstitutionsGlobalViewModel;
}
